<template>
  <div class="app-container">
    <list ref="list"></list>
    <edit-dialog ref="editDialog"></edit-dialog>
  </div>
</template>

<script>
import list from '@/components/attendance/night/list.vue'
import editDialog from '@/components/attendance/night/editDialog.vue'
export default {
  name: "night",
  components:{
    editDialog,
    list
  },
  data() {
    return {
    }
  },
  methods: {
    callNames(){
      this.$refs.editDialog.open();
    },
  },
}
</script>